<body class="ltr main-body leftmenu">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-8">
                    <div class="d-flex align-items-center pl-3">
                      <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>Exam Dashboard</b></h3>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>

                <div class="row clearfix mt-2">
                  <div class="table-responsive table-container tab mt-1">
                    <table class="table table-bordered text-left">
                      <thead>
                        <tr class="text-left">
                          <th class="f600">Session</th>
                          <th class="f600">Exam</th>
                          <th class="f600">Course</th>
                          <th class="f600">College</th>
                          <th class="f600 text-center">Exam Form</th>
                          <th class="f600 text-center">Exam Fee</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let exam of examRows">
                          <td>{{ exam.sessionDisplayName || exam.session }}</td>
                          <td>{{ exam.examName }}</td>
                          <td>{{ exam.courseName }}</td>
                          <td>{{ exam.collegeName }}</td>
                          <td class="text-center">
                            <ng-container *ngIf="!exam.disabled; else notEligibleMessage">
                              <button type="button" class="btn sz btn-primary btn-icon-text"
                                      (click)="goToExamForm(exam.emId, exam.coCode, exam.cgCode, exam.session)"
                                      [disabled]="!sessionName">
                                <span style="display: contents; align-items: center;">
                                  <img width="20vh" style="margin-right: 5px;" src="../../assets/images/form-icon.png" alt="">
                                  Form
                                </span>
                              </button>
                            </ng-container>
                            <ng-template #notEligibleMessage>
                              <span class="text-danger font-weight-bold" style="font-size: 12px;">
                                Your previous result is on withheld so you cannot fill the form, kindly contact with your college administration
                              </span>
                            </ng-template>
                          </td>
                          <td class="text-center">
                            <ng-container *ngIf="!exam.disabled; else notEligibleMessageFee">
                              <button type="button" class="btn sz btn-primary btn-icon-text"
                                      (click)="goToExamFee(exam.emId, exam.coCode, exam.cgCode, exam.session)"
                                      [disabled]="!sessionName">
                                <span style="display: contents; align-items: center;">
                                  <img width="20vh" style="margin-right: 5px;" src="../../assets/images/fee-icon.png" alt="">
                                  Fee
                                </span>
                              </button>
                            </ng-container>
                            <ng-template #notEligibleMessageFee>
                              <span class="text-danger font-weight-bold" style="font-size: 12px;">
                                Not Eligible
                              </span>
                            </ng-template>
                          </td>
                        </tr>
                        <tr *ngIf="examRows.length === 0">
                          <td colspan="6" class="text-center">No exam data available</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>